import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogoutPage = () => {
  const navigate = useNavigate();
  const logoSrc = "./Unext_Logo(Black).png";

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      navigate("/logout", { replace: true });
    };
  }, [navigate]);

  return (
    <div style={styles.pageContainer}>
      <div style={styles.logoutBox}>
      <img src={logoSrc} alt="Logo" style={styles.logo} />
        <h5 style={styles.message}>
          Thank you for your participation! Your responses have been recorded successfully. Our team is currently processing your results, and it would be shared with you shortly.
        </h5>
        <h5 style={styles.message}>
          If you have any questions or need further assistance, please feel free to contact us. <strong></strong>.
        </h5>
     <footer style={styles.footer}>
          &copy; { new Date().getFullYear()} UNext Learning Pvt Ltd. All rights reserved.
        </footer>   
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh",
    width:"500px",
  //  backgroundColor: "#F79646",
 backgroundColor:"#F8F9FA",
border: "0.5px solid orange",
  },

  logo: {
    width: "150px", // Adjust the size of the logo as needed
    margin: "0 auto 20px auto",
    display: "block",
  },
  logoutBox: {
    width: "90%",
    maxWidth: "600px",
    padding: "20px",
    textAlign: "center",
 backgroundColor:" #F8F9FA",
    //backgroundColor:"#F79646",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
    
    
  },
  message: {
    fontSize: "12px",
    //color: "white",
    margin: "10px 0",
    lineHeight: "1.5",

 color: "#1F2937",
    fontFamily: '"Proxima Nova", Arial, sans-serif'
  },

footer: {
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    color: "black",
    fontSize: "10px",
  },
};

export default LogoutPage;
